/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PlaquePersonnePhysiqueDto } from '../models/plaque-personne-physique-dto';


/**
 * Fonctions de gestion des plaques des personnes physiques
 */
@Injectable({
  providedIn: 'root',
})
export class PlaquesPersonnePhysiqueService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation plaquePersonnePhysiqueGetList
   */
  static readonly PlaquePersonnePhysiqueGetListPath = '/api/plaques-personne-physique/list';

  /**
   * Renvoie la liste des plaques de personnes physiques.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquePersonnePhysiqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquePersonnePhysiqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PlaquePersonnePhysiqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonnePhysiqueService.PlaquePersonnePhysiqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlaquePersonnePhysiqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de personnes physiques.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquePersonnePhysiqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquePersonnePhysiqueGetList(params?: {
  }): Observable<Array<PlaquePersonnePhysiqueDto>> {

    return this.plaquePersonnePhysiqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PlaquePersonnePhysiqueDto>>) => r.body as Array<PlaquePersonnePhysiqueDto>)
    );
  }

  /**
   * Path part for operation plaquePersonnePhysiqueLoadList
   */
  static readonly PlaquePersonnePhysiqueLoadListPath = '/api/plaques-personne-physique/load-list';

  /**
   * Renvoie la liste des plaques de personnes physiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquePersonnePhysiqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquePersonnePhysiqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonnePhysiqueService.PlaquePersonnePhysiqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de personnes physiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquePersonnePhysiqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquePersonnePhysiqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.plaquePersonnePhysiqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation plaquePersonnePhysiqueGet
   */
  static readonly PlaquePersonnePhysiqueGetPath = '/api/plaques-personne-physique/{id}';

  /**
   * Renvoie la plaque de personnes physiques spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquePersonnePhysiqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquePersonnePhysiqueGet$Response(params: {

    /**
     * Identifiant de la plaque de personnes physiques
     */
    id: number;
  }): Observable<StrictHttpResponse<PlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonnePhysiqueService.PlaquePersonnePhysiqueGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie la plaque de personnes physiques spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquePersonnePhysiqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquePersonnePhysiqueGet(params: {

    /**
     * Identifiant de la plaque de personnes physiques
     */
    id: number;
  }): Observable<PlaquePersonnePhysiqueDto> {

    return this.plaquePersonnePhysiqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<PlaquePersonnePhysiqueDto>) => r.body as PlaquePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation plaquePersonnePhysiquePut
   */
  static readonly PlaquePersonnePhysiquePutPath = '/api/plaques-personne-physique/{id}';

  /**
   * Met à jour la plaque de personnes physiques spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquePersonnePhysiquePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquePersonnePhysiquePut$Response(params: {

    /**
     * Identifiant de la plaque de personnes physiques
     */
    id: number;

    /**
     * Plaque de personnes physiques
     */
    body: PlaquePersonnePhysiqueDto
  }): Observable<StrictHttpResponse<PlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonnePhysiqueService.PlaquePersonnePhysiquePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Met à jour la plaque de personnes physiques spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquePersonnePhysiquePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquePersonnePhysiquePut(params: {

    /**
     * Identifiant de la plaque de personnes physiques
     */
    id: number;

    /**
     * Plaque de personnes physiques
     */
    body: PlaquePersonnePhysiqueDto
  }): Observable<PlaquePersonnePhysiqueDto> {

    return this.plaquePersonnePhysiquePut$Response(params).pipe(
      map((r: StrictHttpResponse<PlaquePersonnePhysiqueDto>) => r.body as PlaquePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation plaquePersonnePhysiqueDelete
   */
  static readonly PlaquePersonnePhysiqueDeletePath = '/api/plaques-personne-physique/{id}';

  /**
   * Supprime la plaque de personnes physiques spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquePersonnePhysiqueDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquePersonnePhysiqueDelete$Response(params: {

    /**
     * Identifiant de la plaque de personnes physiques à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonnePhysiqueService.PlaquePersonnePhysiqueDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la plaque de personnes physiques spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquePersonnePhysiqueDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquePersonnePhysiqueDelete(params: {

    /**
     * Identifiant de la plaque de personnes physiques à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.plaquePersonnePhysiqueDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation plaquePersonnePhysiquePost
   */
  static readonly PlaquePersonnePhysiquePostPath = '/api/plaques-personne-physique';

  /**
   * Crée la plaque de personnes physiques spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquePersonnePhysiquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquePersonnePhysiquePost$Response(params: {

    /**
     * Plaque de personnes physiques
     */
    body: PlaquePersonnePhysiqueDto
  }): Observable<StrictHttpResponse<PlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonnePhysiqueService.PlaquePersonnePhysiquePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Crée la plaque de personnes physiques spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquePersonnePhysiquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquePersonnePhysiquePost(params: {

    /**
     * Plaque de personnes physiques
     */
    body: PlaquePersonnePhysiqueDto
  }): Observable<PlaquePersonnePhysiqueDto> {

    return this.plaquePersonnePhysiquePost$Response(params).pipe(
      map((r: StrictHttpResponse<PlaquePersonnePhysiqueDto>) => r.body as PlaquePersonnePhysiqueDto)
    );
  }

}
